// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import { Menu, MenuItem, Slider, Pagination } from "element-ui";
import 'element-ui/lib/theme-chalk/index.css'
import "@/assets/css/reset.css";
import "@/assets/css/swiper.min.css";
import "@/assets/iconfont/iconfont.css";

import VueAwesomeSwiper from "vue-awesome-swiper";
Vue.use(VueAwesomeSwiper);

// import echarts from 'echarts'
// Vue.prototype.$echarts = echarts

Vue.use(Menu);
Vue.use(MenuItem);
Vue.use(Slider);
Vue.use(Pagination);

Vue.config.productionTip = false;
Array.prototype.shuffle = function () {
  let m = this.length,
    i;
  while (m) {
    i = (Math.random() * m--) >>> 0;
    [this[m], this[i]] = [this[i], this[m]];
  }
  return this;
};
// router.afterEach((to,from,next)=>{
//   window.scrollTo(0,0)
// })
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  render: (h) => h(App),
});
